import thunk from "redux-thunk";
import { applyMiddleware, createStore } from "redux";
import RootReducer from "../Reducers/RootReducer";
const store = createStore(RootReducer, applyMiddleware(thunk));

export default store;
